import { DataTable } from "@/components/data-table";
import { historiesColumns } from "@/features/history/components/histories-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useHistoryList } from "@/features/history/hooks/useHistoryList";
import { useHistoryFilters } from "@/features/history/hooks/useHistoryFilters";
import ListContent from "@/features/history/components/list-content";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";
import SearchInput from "@/components/search-input";
import HistoryFilterComponent from "@/features/history/components/history-filter-component";

const HistoryPage = () => {
  const { t } = useTranslation();
  const {
    histories,
    page,
    pageCount,
    setPage,
    isLoading,
    isFetching,
    objectPk,
  } = useHistoryList();
  const [filters, setFilters] = useHistoryFilters();

  const clearObjectPkFilter = () => {
    setFilters({ object_pk: null, model_type: null });
  };

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      {/* Mobile/Tablet: search + dropdown filter (below xl) */}
      <div className="flex items-center gap-2 xl:hidden px-3 sm:px-6">
        <SearchInput
          value={filters.search ?? ""}
          onChange={(v) => setFilters({ search: v || null })}
          placeholder={t("modules.history.keys.search_placeholder")}
          className="lg:hidden"
        />
        <div className="lg:hidden">
          <HistoryFilterComponent />
        </div>
      </div>

      {objectPk && (
        <Alert variant="warning" className="mx-3 sm:mx-6 w-auto">
          <AlertDescription className="flex items-center flex-wrap gap-2">
            <Info className="size-4" />
            <p className="mr-2 text-xs md:text-base">
              {t("modules.history.filtered_banner.title")}
            </p>
            <Button
              variant="ghost"
              className="bg-orange-500/10 hover:bg-orange-500/20 text-orange-900 hover:text-orange-900"
              size="xs"
              onClick={clearObjectPkFilter}
            >
              {t("modules.history.filtered_banner.clear")}
            </Button>
          </AlertDescription>
        </Alert>
      )}
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={historiesColumns(t)}
          data={histories}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
        />
      </div>
      <ListContent
        data={histories}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
      />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  return <EmptyTable title={t("modules.history.datatable.no_histories")} />;
};

export default HistoryPage;
